module.exports = __webpack_public_path__ + "img/ref-banner.2d34dce2.png";